export const version = 'v2.78.0-10-g92281898';
